import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { LinkOff } from '@material-ui/icons'

import useStyles from './styles'

const InvalidLinkScreen = () => {
  const classes = useStyles()

  return (
    <Box display="flex" flexDirection="column" alignItems="center" py={2}>
      <LinkOff color="disabled" style={{ fontSize: 48, marginBottom: 16 }} />
      <Typography color="primary" className={classes.title}>
        Link indisponível
      </Typography>
      <Typography className={classes.message}>
        Este link de acesso é inválido ou não está mais ativo. Entre em contato
        com o responsável pelo treinamento para obter um novo link.
      </Typography>
    </Box>
  )
}

export default InvalidLinkScreen
